import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { BoxTab } from './box-tab';

@Component({
  selector: 'rl-box-tabs',
  templateUrl: './box-tabs.component.html',
  styleUrls: ['./box-tabs.component.scss', './box-tabs.component-rtl.css']
})
export class BoxTabsComponent implements OnInit{

  @Input() tabs : BoxTab[] = [];
  @Output() onSelect : EventEmitter<string> = new EventEmitter<string>();

  ngOnInit(){
    if(this.tabs?.length == 1){
      this.onSelect.emit(this.tabs[0].code);
    }
  }
}
